(() => {
  const getGalleryI18n = () => {
    const node = document.getElementById('dh-pdp-editorial-i18n');
    if (!node) return { images: '', previous: '', next: '', view: '{index} / {total}' };

    try {
      const data = JSON.parse(node.textContent || '{}');
      return {
        images: data.images || '',
        previous: data.previous || '',
        next: data.next || '',
        view: data.view || '{index} / {total}',
      };
    } catch (error) {
      console.warn('DH PDP i18n payload could not be parsed.', error);
      return { images: '', previous: '', next: '', view: '{index} / {total}' };
    }
  };

  const init = (root) => {
    if (root.dataset.customDhPdpEditorialReady === 'true') return;
    const gallery = root.querySelector('.product__media-list');
    const modal = root.querySelector('product-modal');
    if (!gallery || !modal) return;
    root.dataset.customDhPdpEditorialReady = 'true';

    const product = root.querySelector('.product');
    const infoColumn = root.querySelector('.product__info-wrapper');
    if (product && infoColumn) {
      let resizeFrame = 0;
      const updateStickyOffset = () => {
        if (window.innerWidth < 960) {
          infoColumn.style.removeProperty('--custom-dh-pdp-sticky-top');
          return;
        }

        const infoRect = infoColumn.getBoundingClientRect();
        const helpLink = infoColumn.querySelector('a[href*="/pages/customer-care"]');
        const paddingBottom = parseFloat(getComputedStyle(infoColumn).paddingBottom) || 0;
        const contentHeight = helpLink
          ? helpLink.getBoundingClientRect().bottom - infoRect.top + paddingBottom
          : Math.max(infoColumn.offsetHeight, infoColumn.scrollHeight);
        const headerHeight = document.querySelector('.section-header')?.getBoundingClientRect().height || 0;
        const stickyTop = `${Math.min(headerHeight, window.innerHeight - contentHeight)}px`;
        if (infoColumn.style.getPropertyValue('--custom-dh-pdp-sticky-top') !== stickyTop) {
          infoColumn.style.setProperty('--custom-dh-pdp-sticky-top', stickyTop);
        }
      };

      const scheduleStickyOffset = () => {
        if (!resizeFrame) {
          resizeFrame = requestAnimationFrame(() => {
            resizeFrame = 0;
            updateStickyOffset();
          });
        }
      };

      window.addEventListener('resize', scheduleStickyOffset);
      const infoResizeObserver = new ResizeObserver(scheduleStickyOffset);
      infoResizeObserver.observe(infoColumn);
      const infoContent = infoColumn.querySelector('.product__info-container');
      if (infoContent) infoResizeObserver.observe(infoContent);
      document.fonts?.ready.then(scheduleStickyOffset);
      updateStickyOffset();
    }

    const content = modal.querySelector('.product-media-modal__content');
    const dialog = modal.querySelector('.product-media-modal__dialog');
    const galleryI18n = getGalleryI18n();
    let allModalMedia = [];
    let media = [];
    let activeIndex = 0;

    const rail = document.createElement('nav');
    rail.className = 'custom-dh-pdp-modal-rail';
    rail.setAttribute('aria-label', galleryI18n.images);

    const controls = document.createElement('div');
    controls.className = 'custom-dh-pdp-modal-controls';
    controls.innerHTML = `<button type="button" data-direction="-1" aria-label="${galleryI18n.previous}">‹</button><span aria-live="polite"></span><button type="button" data-direction="1" aria-label="${galleryI18n.next}">›</button>`;
    const count = controls.querySelector('span');

    const showMedia = (index) => {
      if (!media.length) return;
      activeIndex = (index + media.length) % media.length;
      allModalMedia.forEach((item) => item.classList.toggle('active', item === media[activeIndex]));
      rail.querySelectorAll('button').forEach((button, buttonIndex) => {
        button.setAttribute('aria-current', String(buttonIndex === activeIndex));
      });
      count.textContent = `${activeIndex + 1} / ${media.length}`;
      content.scrollTop = 0;
      content.scrollLeft = 0;
      const activeMedia = media[activeIndex];
      if (modal.hasAttribute('open') && activeMedia.tagName === 'DEFERRED-MEDIA' && typeof activeMedia.loadContent === 'function') {
        activeMedia.loadContent(false);
      }
    };

    const rebuildMedia = () => {
      allModalMedia = Array.from(content.querySelectorAll(':scope > [data-media-id]'));
      media = Array.from(gallery.querySelectorAll(':scope > [data-media-id]'))
        .map((item) => allModalMedia.find((modalItem) => item.dataset.mediaId.endsWith(`-${modalItem.dataset.mediaId}`)))
        .filter(Boolean);
      rail.replaceChildren();
      media.forEach((item, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'custom-dh-pdp-modal-thumb';
        button.setAttribute(
          'aria-label',
          galleryI18n.view
            .replace('{index}', String(index + 1))
            .replace('{total}', String(media.length))
        );
        const image = document.createElement('img');
        image.src = item.currentSrc || item.src || item.querySelector('img')?.currentSrc || item.querySelector('img')?.src || '';
        image.alt = '';
        image.loading = 'lazy';
        button.appendChild(image);
        button.addEventListener('click', () => showMedia(index));
        rail.appendChild(button);
      });
      showMedia(0);
    };

    dialog.append(rail, controls);
    dialog.addEventListener('pointerup', (event) => {
      if (!event.target.closest('.product-media-modal__toggle')) event.stopPropagation();
    });
    rebuildMedia();
    let rebuildQueued = false;
    const queueRebuild = () => {
      if (rebuildQueued) return;
      rebuildQueued = true;
      queueMicrotask(() => {
        rebuildQueued = false;
        rebuildMedia();
      });
    };
    new MutationObserver(queueRebuild).observe(gallery, { childList: true });
    new MutationObserver(queueRebuild).observe(content, { childList: true });

    const getBuyButton = () => root.querySelector('.product-form__submit');
    if (getBuyButton()) {
      const stickyBuyButton = document.createElement('button');
      stickyBuyButton.type = 'button';
      stickyBuyButton.className = 'button custom-dh-pdp-sticky-cta';
      stickyBuyButton.hidden = true;
      stickyBuyButton.addEventListener('click', () => getBuyButton()?.click());
      root.appendChild(stickyBuyButton);

      Array.from(document.querySelectorAll('.custom-dh-pdp-desktop-sticky-bar'))
        .filter((bar) => bar.dataset.owner === root.id)
        .forEach((bar) => bar.remove());

      const desktopBar = document.createElement('div');
      desktopBar.className = 'custom-dh-pdp-desktop-sticky-bar';
      desktopBar.dataset.owner = root.id;
      desktopBar.setAttribute('aria-hidden', 'true');
      desktopBar.innerHTML =
        '<div class="custom-dh-pdp-desktop-sticky-bar__product">' +
          '<img class="custom-dh-pdp-desktop-sticky-bar__image" alt="">' +
          '<div class="custom-dh-pdp-desktop-sticky-bar__identity">' +
            '<p class="custom-dh-pdp-desktop-sticky-bar__title"></p>' +
            '<p class="custom-dh-pdp-desktop-sticky-bar__price"></p>' +
          '</div>' +
        '</div>' +
        '<div class="custom-dh-pdp-desktop-sticky-bar__options"></div>' +
        '<button type="button" class="button custom-dh-pdp-desktop-sticky-bar__cta"></button>';
      document.body.appendChild(desktopBar);

      const desktopImage = desktopBar.querySelector('.custom-dh-pdp-desktop-sticky-bar__image');
      const desktopTitle = desktopBar.querySelector('.custom-dh-pdp-desktop-sticky-bar__title');
      const desktopPrice = desktopBar.querySelector('.custom-dh-pdp-desktop-sticky-bar__price');
      const desktopOptions = desktopBar.querySelector('.custom-dh-pdp-desktop-sticky-bar__options');
      const desktopCta = desktopBar.querySelector('.custom-dh-pdp-desktop-sticky-bar__cta');
      desktopCta.addEventListener('click', () => getBuyButton()?.click());

      const getPriceText = () => {
        const price = root.querySelector('[id^="price-"] .price');
        if (!price) return '';
        const sale = price.querySelector('.price__sale .price-item--sale');
        const regular = price.querySelector('.price__regular .price-item--regular') || price.querySelector('.price-item--regular');
        const node = sale && getComputedStyle(sale).display !== 'none' ? sale : (regular || sale);
        return node?.textContent.replace(/\s+/g, ' ').trim() || '';
      };

      const getVariant = () => {
        const node = root.querySelector('variant-selects [data-selected-variant]');
        if (!node) return null;
        try { return JSON.parse(node.textContent || 'null'); } catch (error) { return null; }
      };

      const getOptions = () =>
        Array.from(root.querySelectorAll('variant-selects .product-form__input'))
          .map((group) => {
            const label = group.querySelector('.form__label');
            if (!label) return null;
            const selectedNode = label.querySelector('[data-selected-value]');
            const checked = group.querySelector('input[type="radio"]:checked');
            const select = group.querySelector('select');
            const value =
              selectedNode?.textContent.trim() ||
              checked?.value?.trim() ||
              select?.selectedOptions?.[0]?.textContent.trim() ||
              '';
            if (!value) return null;

            let name = '';
            Array.from(label.childNodes).some((node) => {
              if (node.nodeType !== Node.TEXT_NODE) return false;
              const value = node.textContent.replace(/\s+/g, ' ').trim();
              if (!value) return false;
              name = value.replace(/:\s*$/, '');
              return true;
            });

            const sourceSwatch = checked?.labels?.[0]?.querySelector('.swatch') || group.querySelector('[data-selected-value] .swatch') || null;
            return { name, value, sourceSwatch };
          })
          .filter(Boolean);

      const renderOptions = () => {
        desktopOptions.replaceChildren();
        getOptions().forEach(({ name, value, sourceSwatch }) => {
          const item = document.createElement('div');
          item.className = 'custom-dh-pdp-desktop-sticky-bar__option';

          if (sourceSwatch) {
            const swatchHost = document.createElement('span');
            swatchHost.className = 'custom-dh-pdp-desktop-sticky-bar__swatch';
            swatchHost.setAttribute('aria-hidden', 'true');
            swatchHost.appendChild(sourceSwatch.cloneNode(true));
            item.appendChild(swatchHost);
          } else if (name) {
            const optionName = document.createElement('span');
            optionName.className = 'custom-dh-pdp-desktop-sticky-bar__option-name';
            optionName.textContent = name + ':';
            item.appendChild(optionName);
          }

          const optionValue = document.createElement('span');
          optionValue.className = 'custom-dh-pdp-desktop-sticky-bar__option-value';
          optionValue.textContent = value;
          item.appendChild(optionValue);
          desktopOptions.appendChild(item);
        });
      };

      let stickyFrame = 0;
      let lastScrollY = window.scrollY;
      let desktopStickyActive = false;
      let desktopHeaderVisible = false;
      let lastScrollDirection = 0;

      const setDesktopStickyState = (active, headerVisible) => {
        desktopStickyActive = active;
        desktopHeaderVisible = active && headerVisible;

        desktopBar.classList.toggle('is-active', desktopStickyActive);
        desktopBar.setAttribute('aria-hidden', String(!desktopStickyActive));

        document.documentElement.classList.toggle(
          'custom-dh-pdp-desktop-sticky-active',
          desktopStickyActive
        );
        document.documentElement.classList.toggle(
          'custom-dh-pdp-desktop-sticky-header-visible',
          desktopHeaderVisible
        );
        document.documentElement.classList.toggle(
          'custom-dh-pdp-desktop-sticky-header-hidden',
          desktopStickyActive && !desktopHeaderVisible
        );
      };

      const updateStickyBuyButton = () => {
        const buyButton = getBuyButton();
        if (!buyButton) return;

        const buttonRect = buyButton.getBoundingClientRect();
        const rootRect = root.getBoundingClientRect();
        const buttonLabel = buyButton.querySelector('span')?.textContent.trim() || buyButton.textContent.trim();
        const desktop = window.innerWidth >= 960;
        const header = document.querySelector('.section-header');
        const headerHeight = desktop ? (header?.offsetHeight || 72) : 0;
        const stickyHeight = desktop ? (desktopBar.offsetHeight || headerHeight || 72) : 0;
        const currentScrollY = window.scrollY;
        const scrollDelta = currentScrollY - lastScrollY;

        if (Math.abs(scrollDelta) > 1) {
          lastScrollDirection = scrollDelta > 0 ? 1 : -1;
          lastScrollY = currentScrollY;
        }

        document.documentElement.style.setProperty(
          '--custom-dh-pdp-sticky-height',
          stickyHeight ? stickyHeight + 'px' : '72px'
        );
        document.documentElement.style.setProperty(
          '--custom-dh-pdp-header-height',
          headerHeight ? headerHeight + 'px' : '72px'
        );

        const productStillActive = rootRect.bottom > headerHeight;
        const downActivationEdge = headerHeight;
        const upDeactivationEdge = headerHeight + stickyHeight;

        if (!desktop || !productStillActive) {
          setDesktopStickyState(false, false);
        } else if (!desktopStickyActive) {
          if (buttonRect.bottom <= downActivationEdge) {
            setDesktopStickyState(true, false);
          }
        } else if (lastScrollDirection < 0) {
          if (buttonRect.bottom > upDeactivationEdge) {
            setDesktopStickyState(false, false);
          } else {
            setDesktopStickyState(true, true);
          }
        } else if (lastScrollDirection > 0) {
          setDesktopStickyState(true, false);
        }

        stickyBuyButton.hidden = desktop || buttonRect.top >= 0 || !productStillActive;
        stickyBuyButton.disabled = buyButton.disabled;
        stickyBuyButton.textContent = buttonLabel;

        desktopCta.disabled = buyButton.disabled;
        desktopCta.textContent = buttonLabel;

        if (desktopStickyActive) {
          desktopTitle.textContent = root.querySelector('.product__title h1')?.textContent.trim() || '';
          desktopPrice.textContent = getPriceText();

          const variant = getVariant();
          const fallbackImage = gallery.querySelector('.product__media-item img') || root.querySelector('.product__media img');
          const imageSrc = variant?.featured_image?.src || fallbackImage?.currentSrc || fallbackImage?.src || '';
          if (imageSrc && desktopImage.src !== imageSrc) desktopImage.src = imageSrc;

          renderOptions();
        }
      };

      const scheduleStickyUpdate = () => {
        if (stickyFrame) return;
        stickyFrame = requestAnimationFrame(() => {
          stickyFrame = 0;
          updateStickyBuyButton();
        });
      };

      window.addEventListener('scroll', scheduleStickyUpdate, { passive: true });
      window.addEventListener('resize', () => {
        if (window.innerWidth < 960) {
          setDesktopStickyState(false, false);
        }
        lastScrollY = window.scrollY;
        scheduleStickyUpdate();
      });
      root.addEventListener('change', () => requestAnimationFrame(scheduleStickyUpdate));

      const productInfo = root.querySelector('.product__info-container');
      if (productInfo) {
        new MutationObserver(scheduleStickyUpdate).observe(productInfo, {
          childList: true,
          subtree: true,
          characterData: true,
        });
      }

      updateStickyBuyButton();
    }

    controls.addEventListener('click', (event) => {
      const button = event.target.closest('button[data-direction]');
      if (button) showMedia(activeIndex + Number(button.dataset.direction));
    });

    gallery.addEventListener('click', (event) => {
      const opener = event.target.closest('.product__media-toggle');
      if (!opener) return;
      const index = media.findIndex((item) => item.dataset.mediaId === opener.dataset.mediaId);
      if (index >= 0) queueMicrotask(() => showMedia(index));
    });

    document.addEventListener('keydown', (event) => {
      if (!modal.hasAttribute('open')) return;
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
        event.preventDefault();
        showMedia(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
      }
    });

    let modalTouch = null;
    content.addEventListener('dragstart', (event) => event.preventDefault());
    content.addEventListener('pointerdown', (event) => {
      modalTouch = { x: event.clientX, y: event.clientY };
    });
    document.addEventListener('pointerup', (event) => {
      if (!modalTouch || !modal.hasAttribute('open')) return;
      const dx = event.clientX - modalTouch.x;
      const dy = event.clientY - modalTouch.y;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) showMedia(activeIndex + (dx < 0 ? 1 : -1));
      modalTouch = null;
    }, true);

    let gesture = null;
    let suppressClick = false;
    gallery.addEventListener('dragstart', (event) => event.preventDefault());
    gallery.addEventListener('pointerdown', (event) => {
      if (window.innerWidth >= 960 || event.pointerType !== 'mouse' || event.button !== 0) return;
      gesture = { x: event.clientX, y: event.clientY, left: gallery.scrollLeft, dragging: false };
      suppressClick = false;
    }, true);
    document.addEventListener('pointermove', (event) => {
      if (!gesture) return;
      const dx = event.clientX - gesture.x;
      const dy = event.clientY - gesture.y;
      if (!gesture.dragging && Math.abs(dx) > 8 && Math.abs(dx) > Math.abs(dy)) gesture.dragging = true;
      if (gesture.dragging) {
        event.preventDefault();
        gallery.style.scrollSnapType = 'none';
        gallery.scrollLeft = gesture.left - dx;
      }
    }, { passive: false });
    document.addEventListener('pointerup', (event) => {
      if (!gesture) return;
      if (gesture.dragging) {
        suppressClick = true;
        gallery.style.scrollSnapType = '';
        const dx = event.clientX - gesture.x;
        const startPage = Math.round(gesture.left / gallery.clientWidth);
        const page = Math.max(0, Math.min(gallery.children.length - 1, startPage + (dx < -45 ? 1 : dx > 45 ? -1 : 0)));
        gallery.scrollTo({ left: page * gallery.clientWidth, behavior: 'smooth' });
      }
      gesture = null;
    });
    gallery.addEventListener('click', (event) => {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      suppressClick = false;
    }, true);
  };

  const initAll = () => document.querySelectorAll('product-info[id^="MainProduct-"]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
